import React from "react";
import { Tooltip } from "react-tooltip";

const TooltipMsSso = ({ expiryDate }) => {
    const parsedExpiry = expiryDate ? new Date(expiryDate.replace(" ", "T")) : null;
    const isExpired = parsedExpiry && parsedExpiry < new Date();

    return (
        <>
            <Tooltip anchorSelect=".signURL" place="right" className="exampleTooltip">
                Your users will be redirected to this page to sign in.
            </Tooltip>

            <Tooltip
                anchorSelect=".Certificate"
                place="right"
                className={`exampleTooltip ${isExpired ? "expiredTooltip" : ""}`}
            >
                {isExpired ? (
                    <div style={{ color: "red", fontWeight: "bold" }}>
                        Certificate has expired on{" "}
                        <span style={{ textDecoration: "underline" }}>{expiryDate}</span>
                    </div>
                ) : (
                    "This should be a valid certificate that comes from your identity provider."
                )}
            </Tooltip>
        </>
    );
};

export default TooltipMsSso;
